import { connect } from 'react-redux';
import { getShowMatureContent, getIsMobile, getIsLoggedIn, getTheme, getThemeSkin, getHasJoinedWithEclipse, getDeviceSupportsWebp, getPublicSession, getDeviceSupportsLazy, getIsCookieBannerVisible, getVerificationEmailAddress, } from '../publicSession/selectors';
import { getFirstTimeFlags } from '../redux/firstTimeFlags/selectors';
import { getPageViewAndComponent } from '../biLogger/redux/selectors';
import { appMounted, appUnmounted, appVisibilityChange, } from '../redux/app/actions';
import { getEnabledFlagsList } from '../redux/flags/selectors';
import { getIsDuperbrowseActive } from '../Duperbrowse/redux/selectors';
import { getCurrentAdSafety } from '../Ads/redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    showMatureContent: getShowMatureContent(state),
    isMobile: getIsMobile(state),
    isLoggedIn: getIsLoggedIn(state),
    theme: ownProps.theme || getTheme(state),
    themeSkin: ownProps.themeSkin || getThemeSkin(state),
    firstTimeFlags: getFirstTimeFlags(state),
    hasJoinedWithEclipse: getHasJoinedWithEclipse(state),
    showCookieBanner: getIsCookieBannerVisible(state),
    supportsWebp: getDeviceSupportsWebp(state),
    supportsLazy: getDeviceSupportsLazy(state),
    publicSession: getPublicSession(state),
    biPageContextData: getPageViewAndComponent(state),
    flags: getEnabledFlagsList(state),
    verificationEmail: getVerificationEmailAddress(state),
    isDuperbrowseActive: getIsDuperbrowseActive(state),
    currentAdSafety: getCurrentAdSafety(state),
}); };
var mapDispatchToProps = {
    appMounted: appMounted,
    appUnmounted: appUnmounted,
    appVisibilityChange: appVisibilityChange,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DaApp.container.js.map